import {
  logIn,
  logOut,
  resetPassword,
  userInfo,
  userReg,
  subscribe,
  newPassword,
  socialLogin,
  emailVerify,
  socialLoginEmailVerification,
  sendCodeRecoveryPassword,
} from './action';

export { authReducer } from './reducer';
export { watchAuth } from './saga';
export {
  LOG_IN,
  LOG_IN_SUCCESS,
  LOG_IN_FAIL,
  LOG_OUT,
  GET_USER_INFO,
  SUBSCRIBE,
  NEW_PASSWORD,
  SOCIAL_LOGIN,
  EMAIL_VERIFY,
  SOCIAL_LOGIN_EMAIL_VERIFICATION,
  PASSWORD_RECOVERY_EMAIL_VERIFY,
} from './types';

export const authActions = {
  userReg,
  logIn,
  logOut,
  resetPassword,
  userInfo,
  subscribe,
  newPassword,
  socialLogin,
  emailVerify,
  socialLoginEmailVerification,
  sendCodeRecoveryPassword,
};
